import React, {useEffect} from 'react'

export const useDebug = (value) => {
  useEffect(()=>{
    console.log(value)
  },[value])
}
